export const CMS_API_ENDPOINT = process.env.REACT_APP_CMS_API_URL || "http://localhost:3000/api";